import { Link } from "react-router-dom";
import type { Business } from "@/types";
import BusinessCard from "@/components/feature/BusinessCard";

export default function FeaturedListings({ businesses }: { businesses: Business[] }) {
  return (
    <section className="border-y border-accent-200 bg-accent-100">
      <div className="mx-auto w-full max-w-[1400px] px-4 py-14 md:px-6 md:py-16">
        <div className="flex flex-col gap-4 md:flex-row md:items-end md:justify-between">
          <div className="max-w-2xl">
            <span className="mb-2 inline-flex items-center gap-2 rounded-full bg-accent-800 px-3 py-1 text-xs font-semibold uppercase tracking-[0.18em] text-accent-50">
              <span className="flex h-4 w-4 items-center justify-center text-primary-300">
                <i className="ri-vip-crown-2-line text-sm"></i>
              </span>
              Featured
            </span>
            <h2 className="font-heading text-2xl font-bold leading-tight text-accent-950 md:text-3xl">
              Featured businesses worth knowing
            </h2>
            <p className="mt-3 text-sm leading-relaxed text-accent-900 md:text-base">
              Premium listings handpicked from across the Mysore region — verified owners customers
              keep coming back to.
            </p>
          </div>
          <Link
            to="/directory"
            className="group inline-flex shrink-0 items-center gap-2 whitespace-nowrap rounded-md bg-accent-800 px-4 py-2.5 text-sm font-semibold text-accent-50 transition-colors duration-200 hover:bg-accent-900 cursor-pointer"
          >
            Browse all businesses
            <i className="ri-arrow-right-line text-base transition-transform duration-200 group-hover:translate-x-0.5"></i>
          </Link>
        </div>

        <div className="mt-8 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-4">
          {businesses.slice(0, 8).map((b) => (
            <BusinessCard key={b.id} business={b} badge="featured" />
          ))}
        </div>
      </div>
    </section>
  );
}